import {observer} from 'mobx-react-lite'
import React, {useEffect, useState} from 'react'
import {
  ImportFromFileContext,
  ImportFromFileStore,
  useImportFromFileStore
} from './import-from-file-store'

import {ErrorPopup} from './error-popup'
import {ImportFromFilePopup} from './import-from-file-popup'

type ImportFromFileProps = {
  isOpen: boolean
  setIsOpen: (state: boolean) => void
}

export const ImportFromFile = (props: ImportFromFileProps) => {
  const {isOpen, setIsOpen} = props
  const [store] = useState(() => new ImportFromFileStore(setIsOpen))

  useEffect(() => {
    store.setOpenState(isOpen)
  }, [isOpen])

  return (
    <ImportFromFileContext.Provider value={store}>
      <ImportFromFilePopup />
      <ImportFromFileError />
    </ImportFromFileContext.Provider>
  )
}

const ImportFromFileError = observer(() => {
  const [state] = useImportFromFileStore()

  return state.isErrorPopupOpen ? <ErrorPopup /> : null
})
